export default "ا\nب\nپ\nت\nث\nج\nچ\nح\nخ\nد\nذ\nر\nز\nژ\nس\nش\nص\nض\nط\nظ\nع\nغ\nف\nق\nک\nگ\nل\nم\nن\nو\nه\nی"